import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import elementPlugin from './plugins/element';
import axios from 'axios';
import store from './store';
import i18n from './i18n';
import eformHomeHttp from './http/eformHomeHttp'; // 路径根据你的项目结构调整
import getEformHomeToken from './http/getEformHomeToken';

// 控制401只弹一次
let isAlerted401 = false;

// 创建 Vue 应用实例
const app = createApp(App);
app.config.globalProperties.$eformHomeHttp = eformHomeHttp;
app.config.globalProperties.$getEformHomeToken = getEformHomeToken;

// 配置 axios 实例
const http = axios.create({
  baseURL: '/api',
});

// 添加请求拦截器
http.interceptors.request.use(config => {
  const apiToken = localStorage.getItem('authToken');
  if (apiToken) {
    config.headers.Authorization = `Bearer ${apiToken}`;
  }
  return config;
});
console.log(localStorage.getItem('company'))
// 添加响应拦截器
http.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      if (!isAlerted401) {
        isAlerted401 = true;
        localStorage.removeItem('authToken');
        const company = localStorage.getItem('company');
        alert('Login has expired. Please log in again');
        if (company === 'HKE') {
          window.location.href = '/admin/the-login';
        } else {
          window.location.href = '/admin/ssoLogout';
        }
      }
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

// 全局挂载 axios
app.config.globalProperties.$axios = http;

// ------------ 多语言路由参数和本地存储同步 --------------
const langMap = {
  'zh-HK': 1,
  'zh-CN': 2,
  'ja': 3,
  'en-HK': 4,
  'ko': 5,
};
const labelMap = {
  'zh-HK': '中文(繁体)',
  'zh-CN': '中文(简体)',
  'ja': '日本語',
  'en-HK': 'English',
  'ko': '한국어',
};
app.use(router);
app.use(store);
app.use(i18n);
elementPlugin(app);

app.mount('#app');
router.beforeEach((to, from, next) => {
  if (to.params.lang) {
    i18n.global.locale.value = to.params.lang; // 现在可以安全地用 .value
    // 同步 localStorage
    if (langMap[to.params.lang]) {
      localStorage.setItem('language', langMap[to.params.lang]);
    }
    if (labelMap[to.params.lang]) {
      localStorage.setItem('languageLabel', labelMap[to.params.lang]);
    }
    localStorage.setItem('languageCode', to.params.lang);

  }
  next();
});
// -----------------------------------------------------

